import type { PluginListItem } from "../api/cli-api.js";

export function formatPluginListTechType(item: PluginListItem): string {
  return item.tech_type ?? item.category ?? item.source ?? "-";
}
